import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';
import { AppRoutes } from '../../App/routes';

export const rolesRoot = 'roles';
export const rolesOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${rolesRoot}`;
export const ROLES_ROUTE_PARAMS = {
  roleName: 'roleName',
};
export const rolesDetailRoute = `${rolesOverviewRoute}/:${ROLES_ROUTE_PARAMS.roleName}/edit`;
